import styles from "./badges.module.scss"

import type { SettlementStatus } from "@/company_admin/gql/__generated__/graphql"

import { statusLabels } from "../settlement.logic"

type Props = {
	status: SettlementStatus
}

const statusStyleMap: Record<SettlementStatus, string> = {
	PENDING: styles.pending,
	CARRYOVER: styles.carryover,
	PAYOUT_IN_PROGRESS: styles.in_progress,
	INVOICE_IN_PROGRESS: styles.in_progress,
	COMPLETED: styles.completed,
}

const StatusBadge = ({ status }: Props) => {
	return (
		<span className={`${styles.badge} ${statusStyleMap[status]}`}>
			{statusLabels[status]}
		</span>
	)
}

export default StatusBadge
